import { RouteItem } from '@eastcoal/router/types/route'

import { BLACKLIST_LIST_PAGE_PATH } from './constants/path'
import {
  BLACKLIST_LIST_ACTION_UUID,
  BLACKLIST_LIST_PAGE_UUID
} from './constants/uuid'

export const blacklistRoute: RouteItem = {
  title: '黑名单',
  path: BLACKLIST_LIST_PAGE_PATH,
  uuid: BLACKLIST_LIST_PAGE_UUID,
  Component: () => import('./List/index'),
  children: [
    {
      title: '新增黑名单',
      uuid: BLACKLIST_LIST_ACTION_UUID
    }
  ]
}
